import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import './index.css';
import { Provider } from 'react-redux';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './store/store';
import App from './App';
import { ModalProvider } from './providers/ModalProvider/ModalProvider';
import { setDispatch } from './store/dispatchAccessor';

const domain = process.env.REACT_APP_AUTH0_DOMAIN!;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID!;
const audience = process.env.REACT_APP_AUTH0_AUDIENCE!;

setDispatch(store.dispatch);

// Small helper to wire navigation after login redirect:
const Auth0ProviderWithNavigate = ({ children }: { children: React.ReactNode }): JSX.Element => {
	const navigate = useNavigate();
	const onRedirectCallback = (appState?: { returnTo?: string }): void => {
		navigate(appState?.returnTo || window.location.pathname, { replace: true });
	};

	return (
		<Auth0Provider
			domain={domain}
			clientId={clientId}
			authorizationParams={{
				redirect_uri: window.location.origin,
				audience,
				scope: 'openid profile email offline_access',
			}}
			useRefreshTokens
			useRefreshTokensFallback
			onRedirectCallback={onRedirectCallback}
		>
			{children}
		</Auth0Provider>
	);
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<BrowserRouter>
				<Auth0ProviderWithNavigate>
					<ModalProvider>
						<App />
					</ModalProvider>
				</Auth0ProviderWithNavigate>
			</BrowserRouter>
		</PersistGate>
	</Provider>
);
